import React, { useState, useEffect } from 'react';
import { Header, Icon, Grid, Button, Embed } from 'semantic-ui-react';
import { servicesAPI, useCurrentUser } from '../../_services';
import '../layout/AON.css';

export const DomesticTariffDetails = ({ customerId }) => {
  const { currentUser } = useCurrentUser();
  const [connectToFlatpeak, setConnectToFlatpeak] = useState('');
  const [tariffName, setTariffName] = useState('Unknown tariff');
  const [tariffRate, setTariffRate] = useState('?');

  useEffect(() => {
    getEnergyTariff();
  }, []); // eslint-disable-line

  const getEnergyTariff = () => {
    servicesAPI.CustomerServices('getAonHost', customerId).then(aonHost => {
      if (!aonHost) return;

      servicesAPI
        .MeteringServices('getFlatpeakTariff', aonHost.flatpeak_id)
        .then(tariff => {
          if (!tariff) return;

          const rate = tariff.rate.toFixed(2);
          setTariffName(tariff.name);
          setTariffRate(`£${rate}`);
        });
    });
  };

  const syncEnergyTariff = () => {
    servicesAPI.MeteringServices('getFlatpeakBearerToken').then(response => {
      const bearerToken = response.token;
      localStorage.setItem('flatpeakBeareroken', bearerToken);

      servicesAPI
        .MeteringServices('getFlatpeakConnectToken', bearerToken)
        .then(response => {
          const connectToken = response.token;
          localStorage.setItem('flatpeakConnectToken', connectToken);
          const url = `https://connect-web.flatpeak.com?fp_cot=${connectToken}`;

          setConnectToFlatpeak(url);
        });
    });
  };

  const saveEnergyTariff = () => {
    const bearerToken = localStorage.getItem('flatpeakBeareroken');
    const connectToken = localStorage.getItem('flatpeakConnectToken');

    if (!bearerToken || !connectToken) return;

    servicesAPI
      .MeteringServices('getFlatpeakLocationId', bearerToken, connectToken)
      .then(location => {
        // Update Flatpeak location id
        const values = {
          flatpeak_id: location.location_id
        };
        servicesAPI.CustomerServices(
          'updateAONHostFlatpeakLocation',
          customerId,
          values
        );

        // Update signup flow state
        servicesAPI
          .AdminServices('getEntityState', 'AON_SIGN_UP', customerId)
          .then(state => {
            if (state) {
              state.flatpeak_id = location.location_id;
              servicesAPI.AdminServices(
                'upsertEntityState',
                'AON_SIGN_UP',
                customerId,
                state
              );
            }
          });

        // Close Flatpeak iframe
        setConnectToFlatpeak('');

        getEnergyTariff();

        servicesAPI.AdminServices(
          'auditUserActivity',
          {
            entity_type: 'CUSTOMER',
            entity_id: customerId,
            activity: 'CustomerConnectFlatpeak',
            notes: `HOME: Updated domestic energy tariff`,
            email_subject: '',
            email_body: ''
          },
          currentUser.id
        );
      });
  };

  if (!connectToFlatpeak)
    return (
      <div>
        <Header as="h3">
          <Icon name="lightning" />
          Domestic Energy Tariff
        </Header>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              {tariffName} ({tariffRate} per kWh)
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Button color="olive" onClick={() => syncEnergyTariff()}>
                Update Domestic Energy Tariff
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );

  return (
    <div>
      <div
        className="aon-modal"
        style={{ width: '100%', margin: '0 auto', maxWidth: '460px' }}
      >
        <span className="aon-buttons">
          <div className="safe-secure">
            <div className="safe-secure-sync2">Safe &amp; secure sync</div>
            <img
              className="safe-secure-logo2"
              src="/images/aon/safe-secure.svg"
              alt="safeSecureLogo2"
            />
          </div>
          <img
            className="flatpeak-logo2"
            src="/images/aon/flatpeak.png"
            alt="flatpeakLogo2"
          />
        </span>
      </div>
      <div>
        <Embed
          active={true}
          style={{
            width: '100%',
            margin: '0 auto',
            maxWidth: '460px',
            minHeight: '900px'
          }}
          iframe={{
            id: 'iframe',
            allowFullScreen: true,
            style: {
              padding: 10
            },
            src: connectToFlatpeak,
            onLoad: e => {
              saveEnergyTariff();
            }
          }}
          source={''}
        />
      </div>
    </div>
  );
};
